export default "__VITE_ASSET__BiMTd93Y__"